import React from "react";
import { Spinner } from "@material-tailwind/react";

const Loader = () => {
  return (
    <div className="h-screen flex justify-center items-center">
      <Spinner className="h-12 w-12" color="gray" />
    </div>
  );
};

export default Loader;
